import React from 'react';
import Modal from './index'
import { db } from '../firebase';
export default class UffrideCharge extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
      config: {

      }
    }
    this.detailModal = React.createRef();
  }
  showModal() {
    this.detailModal.current.setState({
      show: true
    })
  }
  hideModal() {
    this.detailModal.current.setState({
      show: false
    })
  }

  render() {
    return (
      <Modal className="fade " ref={this.detailModal} id={this.props.id}
        title="Uffride Service Charge"
        body={
          <div className="modal-body">
            <table className="table table-striped table-bordered">
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li className="row">
                        <div className="col-lg-6"><strong>Uffride Service Charge</strong></div>
                        <div className="col-lg-6"><input value={this.state.config.commission} type="number" min="0" max="25" onChange={e => {
                          let config = this.state.config;
                          config.commission = Number(e.target.value);
                          this.setState({
                            config
                          })
                        }} /></div>
                      </li>
                      <li className="row">
                        <div className="col-lg-6"><strong>Stripe Service Charge</strong></div>
                        <div className="col-lg-6"><input value={this.state.config.stripe} type="number" min="0" max="25" onChange={e => {
                          let config = this.state.config;
                          config.stripe = Number(e.target.value);
                          this.setState({
                            config
                          })
                        }} /></div>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        }
        footer={
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={e => {
              db.updateConfigWithKey("", this.state.config);
              this.hideModal();
            }}>Update Service Charge</button>
          </div>
        }
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/modal/UffrideCharge.js